import React, { useEffect, useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import DialogUI from './DialogUI';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { getAttachmentUrl } from '../../utils/fileTabHelper';

const FilePreviewDialog = ({ open, files = [], selectedIndex = 0, handleClose }) => {
  const [index, setIndex] = useState(selectedIndex);
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (open) setIndex(selectedIndex);
  }, [open, selectedIndex]);

  const file = files[index];

  useEffect(() => {
    if (!open || !file) {
      setUrl(null);
      return;
    }

    if (file instanceof File) {
      const objectUrl = URL.createObjectURL(file);
      setUrl(objectUrl);

      return () => URL.revokeObjectURL(objectUrl);
    }

    setUrl(getAttachmentUrl(file.path));
  }, [open, file]);

  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (event) => {
      if (event.key === 'ArrowLeft') {
        setIndex((prev) => Math.max(0, prev - 1));
      }

      if (event.key === 'ArrowRight') {
        setIndex((prev) => Math.min(files.length - 1, prev + 1));
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [open, files.length]);

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      fullWidth
      headerContent={
        <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
          <Typography noWrap sx={{ flex: 1 }}>
            {file?.name}
          </Typography>

          <Typography fontSize={16}>
            {files.length ? index + 1 : 0} / {files.length}
          </Typography>
        </Box>
      }
      closeBtn
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '1200px',
            mx: 1,
          },
        },
        '& .MuiDialogContent-root': {
          px: 0.5,
        },
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={{ xs: '8px 0 0', sm: 2 }}
        gap={{ xs: 0, sm: 1 }}
      >
        <IconButton
          disabled={index === 0}
          onClick={() => setIndex((prev) => prev - 1)}
          sx={{ flexShrink: 0, p: { xs: 0.5, sm: 1 } }}
        >
          <ChevronLeftIcon sx={{ fontSize: { xs: 26, sm: 35 } }} />
        </IconButton>

        <Box
          component="img"
          src={url}
          alt={file?.name || ''}
          sx={{
            maxWidth: '100%',
            maxHeight: '75vh',
            minWidth: 0,
            objectFit: 'contain',
          }}
        />

        <IconButton
          disabled={index >= files.length - 1}
          onClick={() => setIndex((prev) => prev + 1)}
          sx={{ flexShrink: 0, p: { xs: 0.5, sm: 1 } }}
        >
          <ChevronRightIcon sx={{ fontSize: { xs: 26, sm: 35 } }} />
        </IconButton>
      </Box>
    </DialogUI>
  );
};

export default FilePreviewDialog;
